module.exports = __webpack_public_path__ + "img/ban.d2dc411f.svg";